var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_877_37419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5488 18.1675C20.6872 18.0753 20.8465 18.0192 21.0122 18.0041C21.1779 17.9891 21.3447 18.0156 21.4975 18.0813L27.3925 20.7225C27.5912 20.8074 27.757 20.9544 27.8651 21.1414C27.9733 21.3284 28.018 21.5455 27.9925 21.76C27.7983 23.2113 27.0836 24.5427 25.9813 25.5065C24.8791 26.4704 23.4642 27.0011 22 27C17.4913 27 13.1673 25.2089 9.97919 22.0208C6.79107 18.8327 5 14.5087 5 10C4.99888 8.53576 5.5296 7.12094 6.49345 6.01867C7.45731 4.9164 8.78869 4.2017 10.24 4.0075C10.4545 3.98202 10.6716 4.0267 10.8586 4.13486C11.0456 4.24302 11.1926 4.40884 11.2775 4.6075L13.9188 10.5075C13.9836 10.659 14.0101 10.8243 13.9957 10.9885C13.9813 11.1527 13.9265 11.3108 13.8363 11.4488L11.165 14.625C11.0702 14.768 11.0142 14.9331 11.0024 15.1042C10.9906 15.2753 11.0233 15.4466 11.0975 15.6013C12.1313 17.7175 14.3188 19.8788 16.4413 20.9025C16.5967 20.9764 16.7688 21.0084 16.9404 20.9955C17.112 20.9825 17.2773 20.9251 17.42 20.8288L20.5488 18.1675Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_877_37419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/Phone Icon.2680652d8967e9577d80c30289cbbb7f.svg";
export { ForwardRef as ReactComponent };